import { TabPill } from 'types/tabs';

export enum LeadSettingIds {
  CALENDAR_CONFERENCING = 'calendar-conferencing',
  LEAD_CONFIGURATION = 'lead-configuration',
  META_INTEGRATION = 'meta-integration'
}

export const leadSettingsTabs: TabPill[] = [
  {
    id: LeadSettingIds.CALENDAR_CONFERENCING,
    label: 'Calendar & Conferencing'
  },
  { id: LeadSettingIds.LEAD_CONFIGURATION, label: 'Configuration' },
  { id: LeadSettingIds.META_INTEGRATION, label: 'Meta integration' }
];

export enum MetaIntegrationTabId {
  LEAD_FORMS = 'lead-forms',
  INSTAGRAM = 'instagram',
  MESSENGER = 'messenger'
}

export const metaIntegrationTabs: (TabPill & { isVisible: boolean })[] = [
  { id: MetaIntegrationTabId.LEAD_FORMS, label: 'Lead forms', isVisible: true },
  { id: MetaIntegrationTabId.INSTAGRAM, label: 'Instagram', isVisible: true },
  { id: MetaIntegrationTabId.MESSENGER, label: 'Messenger', isVisible: true }
];

export const MIN_SELECTABLE_DATE = new Date(
  Date.now() - 90 * 24 * 60 * 60 * 1000
);

// Meta constants
export const META_BUSINESS_SETTINGS_URL =
  'https://business.facebook.com/settings';

export const META_STEP_STYLE =
  'font-normal text-base leading-5 tracking-normal align-middle text-textblack';

export const META_PERMISSIONS = [
  'pages_show_list',
  'leads_retrieval',
  'pages_read_engagement',
  'pages_manage_metadata',
  'pages_manage_ads'
];

// Permissions the backend checks on the token for each DM channel.
export const MESSENGER_PERMISSIONS = [
  'pages_messaging',
  'pages_manage_metadata',
  'pages_read_engagement',
  'pages_show_list'
];

export const INSTAGRAM_PERMISSIONS = [
  'instagram_business_basic',
  'instagram_business_manage_messages'
];

export const META_APP_DASHBOARD_URL = 'https://developers.facebook.com/apps';

export const META_ACCESS_TOKEN_VARIANT = {
  MODAL: 'modal',
  ACCORDION: 'accordion'
} as const;
